import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Assinalar esta página',
  title: 'Assinalar um problema nesta página',
  reasons: {
    'inaccurate-or-fabricated': 'Informação incorreta ou inventada',
    'wrong-product': 'Os produtos não correspondem à página',
    'sexually-explicit': 'Conteúdo sexualmente explícito',
    'regulated-product': 'Produto sujeito a receita ou regulamentado',
    'dangerous-product': 'Produto perigoso',
    'ip-infringement': 'Viola os meus direitos (marca/direitos de autor)',
    other: 'Outro motivo',
  },
  detail: 'Detalhes (opcional)',
  submit: 'Enviar sinalização',
  cancel: 'Cancelar',
  sent: 'Obrigado. Analisamos as sinalizações no prazo de 24 horas.',
  failed: 'Não foi possível enviar a sinalização. Por favor, tente novamente.',
};
